import { useState, useRef, useEffect } from "react"
import { Link, useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"

import { ZaveIcon } from "../../../assets/icons/ZaveIcon"
import { HomeIcon } from "../../../assets/icons/HomeIcon"
import { WalletIcon } from "../../../assets/icons/WalletIcon"
import { BrandIcon } from "../../../assets/icons/BrandIcon"
import { CategoryIcon } from "../../../assets/icons/CategoryIcon"
import { OfferIcon } from "../../../assets/icons/OfferIcon"
import { OrderIcon } from "../../../assets/icons/OrderIcon"
import { TransactionIcon } from "../../../assets/icons/TransactionIcon"
import { AccountIcon } from "../../../assets/icons/AccountIcon"
import * as authHandlers from "../../../routes/Auth/redux/handlers"



function NavLink({ name, ...params}) {
    return (
        <Link {...params} className="w-36 py-2 px-3 flex gap-x-2 justify-center items-center text-sm text-center border border-zinc-700 rounded-full hover:bg-gray-700">
            {name === "Home" && <HomeIcon />}
            {name === "Vendors" && <WalletIcon />}
            {name === "Brands" && <BrandIcon />}
            {name === "Sub Brands" && <BrandIcon />}
            {name === "Categories" && <CategoryIcon />}
            {name === "Orders" && <OrderIcon />}
            {name === "Transactions" && <TransactionIcon />}
            {/* {name === "Offers" && <OfferIcon />}
            {name === "Accounts" && <AccountIcon />} */}

            {name}
        </Link> 
    )
}

function Header() {
    const [showDropdown, setShowDropdown] = useState(false)
    const dropdownRef = useRef(null)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [])

    const handleLogout = async () => {
        await dispatch(authHandlers.logoutHandler())
        navigate('/auth/login')
    }

    return (
        <header className="flex justify-between text-white p-4">
            <div className="flex items-center gap-x-4">
                <ZaveIcon size={44} />
                
                <nav className="flex space-x-2">
                    <NavLink to="/admin/home" name="Home" />
                    <NavLink to="/admin/vendors" name="Vendors" />
                    <NavLink to="/admin/categories" name="Categories" />
                    <NavLink to="/admin/brands" name="Brands" />
                    <NavLink to="/admin/sub-brands" name="Sub Brands" />
                    <NavLink to="/admin/orders" name="Orders" />
                    <NavLink to="/admin/transactions" name="Transactions" />
                    {/* <NavLink to="/admin/offers" name="Offers" />
                    <NavLink to="/admin/accounts" name="Accounts" /> */}
                </nav>
            </div>
            <div className="relative" ref={dropdownRef}>
                <button 
                    onClick={() => setShowDropdown(!showDropdown)}
                    className="py-2.5 px-2.5 text-sm text-center block border border-zinc-700 rounded-full hover:bg-gray-700"
                >
                    <AccountIcon />
                </button>
                {showDropdown && (
                    <div className="absolute right-0 mt-2 w-48 bg-eerie-black border border-zinc-700 rounded-2xl shadow-lg z-50 overflow-hidden">
                        <button
                            onClick={handleLogout}
                            className="w-full text-left px-4 py-3 text-sm text-zinc-300 hover:bg-charleston-green hover:text-white transition-colors"
                        >
                            Logout
                        </button>
                    </div>
                )}
            </div>
        </header>
    )
}

export default Header